// src/pages/Dashboard/components/GreetingHeader.jsx
// STATUS: stable | UPDATED: 2026-08-02
// LOG:
//   2026-08-02  Header standardized; Phase 1 checkpoint committed (e765830).
// Time-aware greeting with the salesperson's first name and initials avatar.
// "Good morning / afternoon / evening, Tyler." Sets the day's intention line.

import { VStack, Heading, Text } from '@chakra-ui/react'

function greetingForHour(h) {
  if (h < 12) return 'Good morning'
  if (h < 18) return 'Good afternoon'
  return 'Good evening'
}

export default function GreetingHeader({ firstName, planCount, minutes }) {
  const greeting = greetingForHour(new Date().getHours())
  const today = new Date().toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' })

  // No avatar and no role here. Both already sit in the header, about eighty
  // pixels above this, so a person landing on their own dashboard was shown
  // their own initials twice and their own job title twice. The greeting is the
  // one thing the header cannot say, so it is all this does.
  return (
    <VStack align="stretch" spacing={1}>
      <Text fontSize="xs" color="inkMuted" letterSpacing="0.08em" textTransform="uppercase">
        {today}
      </Text>
      <Heading textStyle="pageTitle">
        {greeting}, {firstName || 'there'}.
      </Heading>
      <Text fontSize="sm" color="inkMuted" mt={1}>
        {planCount} {planCount === 1 ? 'thing' : 'things'} today. About {minutes} minutes.
      </Text>
    </VStack>
  )
}
